import { ContactSlugEnum } from '@systemeio/ui'
import { InitFieldsInterface } from 'modules/stores/store/components/contact-fields'

export const optinInitFields: InitFieldsInterface[] = [
  { slug: ContactSlugEnum.Email, mandatory: true, required: true },
]
